import Component from '@ember/component';
import layout from '../templates/components/get-outlet-state';

export default Component.extend({
  tagName: '',
  layout
});
